var $5847a002bd1a8278$exports = {};
$5847a002bd1a8278$exports = {
    "decrease": (args)=>`${args.fieldLabel} azalt`,
    "increase": (args)=>`${args.fieldLabel} artt\u{131}r`,
    "numberField": `Say\u{131} alan\u{131}`
};


export {$5847a002bd1a8278$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
